import React from 'react';
import { CiHospital1 } from 'react-icons/ci';
import PageHeader from '@/components/common/PageHeader';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaCar } from 'react-icons/fa';
import { FaTaxi } from 'react-icons/fa';
import { FaHandsHelping } from 'react-icons/fa';
const TransportCenterPage = () => {
  const isMobile = window.innerWidth <= 768;

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className=" lg:max-w-[75rem] 2xl:max-w-layout mx-auto font-notoSans sm:px-8 lg:px-0 lg:mt-[5rem]">
      <PageHeader
        icon={CiHospital1}
        title="병원이송센터"
        bannerImage={
          isMobile
            ? '/images/main/main_02 3.jpg'
            : '/images/transport/image.jpg'
        }
      />

      <div className="mt-10">
        {/* 설명 텍스트 */}
        <div className=" text-lg leading-loose mb-12 text-gray-700">
          신장장애인들은 투석 후{' '}
          <strong className="text-red-600">
            전해질 불균형으로 인한 고혈압, 저혈압, 빈혈증세(어지러움증),
            근육마비 등의 위험에 노출되어 있습니다.
          </strong>{' '}
          이에, 투석 후 바로 자가운전과 대중교통 이동의 위험과 택시 또는 부르미
          이용 시 경제적 부담을 해소하고자 병원이송센터를 운영합니다.
          <br />
          <strong>
            <div className="flex items-center gap-2 text-blue-600">
              <FaTaxi />
              <span>
                투석 병원으로 이동 시, 택시나 부르미 이용으로 발생하는 경제적
                부담 경감
              </span>
            </div>
          </strong>
          <strong>
            <div className="flex items-center gap-2 text-green-600">
              <FaHandsHelping />
              <span>
                대중교통 접근이 어려운 대상자 및 거동이 불편한 환자의 귀가 도움
              </span>
            </div>
          </strong>
        </div>

        {/* 주요사업 및 일반현황 */}
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1 sm:space-y-4 lg:space-y-12 sm:mb-4 lg:mb-0">
            {/* 운영안내 */}
            <div>
              <h2 className="text-2xl font-bold mb-6 text-indigo-700">
                운영안내
              </h2>
              <p className="text-lg leading-loose text-gray-700">
                병원이송서비스는{' '}
                <strong className="text-indigo-600">
                  병원이송서비스는 주중(월-금) 운영으로 울산 관내 혈액투석병원을
                  이용하는 신장장애인 중 거동이 불편하거나 거주지와 병원 간의
                  거리가 먼 경우 최소한의 비용으로 이동 혜택을 받을 수 있습니다
                </strong>
                <br />
                <div className="flex items-center gap-2 text-blue-600">
                  <FaCar />
                  <span>
                    <strong>운행차량 : 승합차 3대(스타렉스)</strong>
                  </span>
                </div>
              </p>
            </div>

            {/* 이용안내 */}
            <div>
              <h2 className="text-2xl font-bold mb-6 text-indigo-700">
                이용안내
              </h2>
              <p className="text-lg leading-loose text-gray-700">
                <p>이용시간 : 월~금 (주말 및 공휴일 제외)</p>
                <br />
                <strong className="text-red-600">
                  병원이송서비스 요금 : 월 30,000원 / 기초생활수급자 및 차상위
                  월 10,000원 (왕복/편도 동일)
                </strong>
              </p>
            </div>

            {/* 이용절차 */}
            <div>
              {/* 데스크톱 버전 */}
              <div className="hidden lg:flex items-center justify-between">
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4 w-[23%]">
                  <p className="text-lg font-bold">회원가입</p>
                </div>
                <div className="text-gray-400">▶</div>
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4 w-[23%]">
                  <p className="text-lg font-bold">병원이송서비스이용 신청</p>
                </div>
                <div className="text-gray-400">▶</div>
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4 w-[23%]">
                  <p className="text-lg font-bold">개별상담/스케줄 조율</p>
                </div>
                <div className="text-gray-400">▶</div>
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4 w-[23%]">
                  <p className="text-lg font-bold">차량배정</p>
                </div>
              </div>

              {/* 모바일 버전 */}
              <div className="lg:hidden flex flex-col space-y-4">
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4">
                  <p className="text-lg font-bold">회원가입</p>
                </div>
                <div className="text-gray-400 self-center">▼</div>
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4">
                  <p className="text-lg font-bold">병원이송서비스이용 신청</p>
                </div>
                <div className="text-gray-400 self-center">▼</div>
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4">
                  <p className="text-lg font-bold">개별상담/스케줄 조율</p>
                </div>
                <div className="text-gray-400 self-center">▼</div>
                <div className="flex flex-col items-center justify-center border border-gray-300 rounded-lg p-4">
                  <p className="text-lg font-bold">차량배정</p>
                </div>
              </div>
            </div>

            {/* 이미지 갤러리 */}
            <div className="my-12">
              {/* 데스크톱 버전 */}
              <div className="hidden lg:grid lg:grid-cols-2 gap-6">
                <div className="">
                  <img
                    src="/images/transport/bottom1.png"
                    alt="프로그램 이미지 1"
                    className="w-full aspect-video object-cover"
                  />
                </div>
                <div className="">
                  <img
                    src="/images/transport/image.png"
                    alt="프로그램 이미지 2"
                    className="w-full aspect-video object-cover"
                  />
                </div>
              </div>

              {/* 모바일 버전 */}
              <div className="lg:hidden">
                <div className="flex flex-col gap-4">
                  <div className="border border-gray-300">
                    <img
                      src="/images/transport/bottom1.png"
                      alt="프로그램 이미지 1"
                      className="w-full aspect-video object-cover sm:h-1/2 md:h-1/2 lg:h-full"
                    />
                  </div>
                  <div className="border border-gray-300">
                    <img
                      src="/images/transport/image.png"
                      alt="프로그램 이미지 2"
                      className="w-full aspect-video object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="text-xl font-bold text-start mb-8 ml-4 w-full lg:max-w-[75rem] 2xl:max-w-layout sm:mb-4 lg:mb-0">
              문의전화 :{' '}
              <a
                href="tel:052-271-7272"
                className="text-blue-500 hover:underline"
              >
                052-271-7272
              </a>
            </div>
          </div>
        </div>

        {/* 이미지 갤러리 */}
      </div>
    </div>
  );
};

export default TransportCenterPage;
